// src/pages/GameCenter.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

function GameCenter() {
  const navigate = useNavigate();

  const games = [
    {
      id: 'fruitninja',
      name: '🍉 水果忍者对战',
      description: '实时匹配，切水果比拼分数',
      icon: '🍉',
      color: 'linear-gradient(135deg, #f39c12, #e67e22)',
      path: '/game'
    },
    {
      id: 'conquest',
      name: '🎨 色彩征服',
      description: '占领格子，颜色最多者胜',
      icon: '🎨',
      color: 'linear-gradient(135deg, #9b59b6, #8e44ad)',
      path: '/conquest'
    },
    {
      id: 'minesweeper',
      name: '💣 双人扫雷',
      description: '实时对战，先完成扫雷者胜',
      icon: '💣',
      color: 'linear-gradient(135deg, #2c3e50, #1a252f)',
      path: '/minesweeper'
    },
    {
        id: 'flappy',
        name: '🐦 Flappy Bird',
        description: '单人/幽灵挑战/联机对战',
        icon: '🐦',
        color: 'linear-gradient(135deg, #f1c40f, #e67e22)',
        path: '/flappy'
    }
  ];

  const goHome = () => {
    navigate('/');
  };

  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: 'var(--color-bg-secondary)',
      padding: '40px 20px'
    },
    header: {
      textAlign: 'center',
      marginBottom: '40px'
    },
    homeButtonWrapper: {
      display: 'flex',
      justifyContent: 'flex-start',
      marginBottom: '20px'
    },
    homeButton: {
      background: '#2c3e50',
      color: 'white',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '30px',
      cursor: 'pointer',
      fontSize: '16px',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'background 0.2s',
      boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
    },
    title: {
      fontSize: '36px',
      fontWeight: 'bold',
      background: 'linear-gradient(135deg, #58a6ff, #1f6feb)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      marginBottom: '10px'
    },
    subtitle: {
      color: 'var(--color-text-secondary)',
      fontSize: '16px'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '30px',
      maxWidth: '900px',
      margin: '0 auto'
    },
    card: {
      backgroundColor: 'var(--color-card-bg)',
      backdropFilter: 'blur(20px)',
      borderRadius: '20px',
      padding: '30px',
      textAlign: 'center',
      cursor: 'pointer',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      border: '1px solid var(--color-card-border)',
      boxShadow: '0 8px 20px rgba(0,0,0,0.1)'
    },
    icon: {
      fontSize: '64px',
      marginBottom: '20px'
    },
    gameName: {
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '10px',
      color: 'var(--color-text-primary)'
    },
    description: {
      color: 'var(--color-text-secondary)',
      marginBottom: '20px',
      lineHeight: 1.5
    },
    button: {
      background: 'var(--color-btn-primary)',
      color: 'white',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '30px',
      fontSize: '16px',
      cursor: 'pointer',
      transition: 'background 0.2s'
    }
  };

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.homeButtonWrapper}>
          <button onClick={goHome} style={styles.homeButton}>
            🏠 返回首页
          </button>
        </div>
        <h1 style={styles.title}>🎮 游戏中心</h1>
        <p style={styles.subtitle}>选择游戏，开始对战！</p>
      </div>
      <div style={styles.grid}>
        {games.map(game => (
          <div
            key={game.id}
            style={styles.card}
            onClick={() => handleCardClick(game.path)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'none';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
            }}
          >
            <div style={styles.icon}>{game.icon}</div>
            <h2 style={styles.gameName}>{game.name}</h2>
            <p style={styles.description}>{game.description}</p>
            <button
              style={styles.button}
              onClick={(e) => {
                e.stopPropagation();
                handleCardClick(game.path);
              }}
            >
              开始游戏
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GameCenter;